import React from 'react';

const Forbidden = (): JSX.Element => {
  return (
    <div style={{ textAlign: 'center' }}>
      <p
        style={{
          marginTop: '2rem',
          fontSize: '1.17rem',
          fontFamily: 'MicrosoftYaHei',
          color: 'rgba(154,154,154,1)',
          lineHeight: '1.58rem',
        }}
      >
        403 Forbidden
      </p>
    </div>
  );
};

export default Forbidden;
